export default "__VITE_ASSET__Bb$DMSe1__"